function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27.32,
    height: 8.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 4.35
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.7,
    width: 27.32,
    height: 30.38,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.553333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 23.89
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.08,
    width: 27.32,
    height: 33.21,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 55.685
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72.29,
    width: 27.32,
    height: 45.73,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 95.155
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 118.02,
    width: 27.32,
    height: 53.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 144.91
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 171.8,
    width: 27.32,
    height: 58.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 201.22000000000003
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 230.64,
    width: 27.32,
    height: 59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.035555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 260.14
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.65,
    width: 27.32,
    height: 59.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.553333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 319.645
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 349.63,
    width: 27.32,
    height: 63.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.553333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 381.435
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.25,
    width: 27.32,
    height: 64.21,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 445.355
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 477.46,
    width: 27.32,
    height: 70.59,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.902857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 512.755
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 548.06,
    width: 27.32,
    height: 74.87,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.902857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 585.4949999999999
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.92,
    width: 27.32,
    height: 77.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.66,
    y: 661.4599999999999
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 0,
    width: 41.92,
    height: 50.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.28,
    y: 25.235
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.25,
    y: 0,
    width: 42.05,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.008333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.275,
    y: 25.235
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 0,
    width: 43.29,
    height: 50.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.184285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.945,
    y: 25.235
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.58,
    y: 0,
    width: 44.83,
    height: 50.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.404285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.995,
    y: 25.235
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.42,
    y: 0,
    width: 45.46,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.14999999999998,
    y: 25.235
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.88,
    y: 0,
    width: 46.17,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.617
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.965,
    y: 25.235
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.05,
    y: 0,
    width: 46.44,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.27,
    y: 25.235
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.49,
    y: 0,
    width: 47.64,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.31,
    y: 25.235
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.13,
    y: 0,
    width: 49.23,
    height: 50.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.745,
    y: 25.235
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.36,
    y: 0,
    width: 49.65,
    height: 50.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.20625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 459.185,
    y: 25.235
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.01,
    y: 0,
    width: 51.41,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.715,
    y: 25.235
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.42,
    y: 0,
    width: 52.05,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.411666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.4449999999999,
    y: 25.235
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.46,
    y: 0,
    width: 55.94,
    height: 50.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.30875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.4300000000001,
    y: 25.235
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.4,
    y: 0,
    width: 56.6,
    height: 50.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.30875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.6999999999999,
    y: 25.235
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 50.47,
    width: 62.53,
    height: 48.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.892
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 74.93
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 99.39,
    width: 62.53,
    height: 49.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.844
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 124
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 148.61,
    width: 62.53,
    height: 51.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 174.245
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 199.88,
    width: 62.53,
    height: 52.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.252000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 226.14
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 252.4,
    width: 62.53,
    height: 54.57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.795714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 279.685
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 306.97,
    width: 62.53,
    height: 59.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 336.61
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 366.24,
    width: 62.53,
    height: 60.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.143333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 396.67
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 427.1,
    width: 62.53,
    height: 64.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.81625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 459.355
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 491.61,
    width: 62.53,
    height: 64.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.684545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 524.095
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 556.58,
    width: 62.53,
    height: 70.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.932857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 591.82
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.32,
    y: 627.06,
    width: 62.53,
    height: 72.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.421666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.585,
    y: 663.53
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 50.47,
    width: 69.29,
    height: 67.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.712857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.495,
    y: 84.465
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.14,
    y: 50.47,
    width: 70.26,
    height: 67.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.49875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.26999999999998,
    y: 84.465
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.4,
    y: 50.47,
    width: 71.14,
    height: 67.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.331666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.97,
    y: 84.465
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.53,
    y: 50.47,
    width: 77.15,
    height: 67.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.712857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.10499999999996,
    y: 84.465
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.69,
    y: 50.47,
    width: 77.57,
    height: 67.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.554444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.475,
    y: 84.465
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.26,
    y: 50.47,
    width: 80.17,
    height: 67.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.49875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.34499999999997,
    y: 84.465
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.44,
    y: 50.47,
    width: 81.07,
    height: 67.99,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.665833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.975,
    y: 84.465
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.51,
    y: 50.47,
    width: 83.49,
    height: 67.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.180909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.255,
    y: 84.465
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 118.46,
    width: 86.54,
    height: 70.14,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.12,
    y: 153.53
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 188.6,
    width: 86.54,
    height: 71.45,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.12,
    y: 224.325
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 260.05,
    width: 86.54,
    height: 72.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.090000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.12,
    y: 296.32
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 332.59,
    width: 86.54,
    height: 75.38,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.537999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.12,
    y: 370.28
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 407.97,
    width: 86.54,
    height: 84.65,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.108333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.12,
    y: 450.295
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 492.61,
    width: 86.54,
    height: 100.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.654
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.12,
    y: 542.785
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 592.97,
    width: 86.54,
    height: 107.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.423333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.12,
    y: 646.485
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.39,
    y: 118.46,
    width: 105.48,
    height: 126.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.580000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.13,
    y: 181.755
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.87,
    y: 118.46,
    width: 114.91,
    height: 126.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.36375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.325,
    y: 181.755
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.78,
    y: 118.46,
    width: 148.68,
    height: 126.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.508181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.12,
    y: 181.755
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.46,
    y: 118.46,
    width: 154.54,
    height: 126.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.098333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.73,
    y: 181.755
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.39,
    y: 245.05,
    width: 179.27,
    height: 129.5,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.583333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.025,
    y: 309.8
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.39,
    y: 374.55,
    width: 179.27,
    height: 148.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 37.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.025,
    y: 448.95000000000005
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.39,
    y: 523.35,
    width: 179.27,
    height: 176.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 35.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.025,
    y: 611.6750000000001
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.66,
    y: 245.05,
    width: 344.34,
    height: 226.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 45.388
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.83,
    y: 358.52
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.66,
    y: 471.99,
    width: 344.34,
    height: 228.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.83,
    y: 585.995
  }, "\n        New_York\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920);
export default __webpack_public_path__ + "static/media/1920.8ed5f34d6c71bc88fccdab3fe4d58b1a.svg";
export { ForwardRef as ReactComponent };